import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable, forkJoin } from 'rxjs';
import { map } from "rxjs/operators";
import { LoaderService } from 'src/app/common/loader.service';
import { MasterService } from '../../../masters/master.service';
import * as CommonConstants from '../../../utils/common.constants';

@Injectable()
export class AddHospitalizationResolver implements Resolve<Observable<any>> {

    SERVICES = ['HOSPI_PLAN_REASON', 'HOSP_PROCEDURE', CommonConstants.EMERGENCY, 'ROOM_TYPE', 'BED_TYPE', 'STATUS',
        CommonConstants.SUBJECTIVE_SIGN, CommonConstants.OBJECTIVE_SIGN, CommonConstants.PATIENT_CONDITION,
        CommonConstants.HOSP_SURGERY_TRANSFER_TO, CommonConstants.HOSP_SURGERY_OPINION, CommonConstants.TRANSFER_PLACE, CommonConstants.HOSPI_REPORT_WAY];
    ptype = [CommonConstants.PARTNER_PRACTITIONER_TYPE, CommonConstants.PARTNER_HOSPITAL_TYPE];


    constructor(private masterService: MasterService, private loader: LoaderService) { }

    resolve(): Observable<any> {
        this.loader.display(true)
        this.masterService.getPartnersByPartnerType(this.ptype);

        return forkJoin([
            this.masterService.getMastersByParamKey(this.SERVICES),
            this.masterService.getSpecialities()
        ]).pipe(
            map(
                ([
                    response,
                    specialitiesResponse
                ]) => {
                    const result = response['result'];
                    const reasons = result.filter(item => item.paramKey === 'HOSPI_PLAN_REASON');
                    const procNames = result.filter(item => item.paramKey === 'HOSP_PROCEDURE');
                    const emergency = result.filter(item => item.paramKey === CommonConstants.EMERGENCY);
                    const roomType = result.filter(item => item.paramKey === 'ROOM_TYPE');
                    const bedType = result.filter(item => item.paramKey === 'BED_TYPE');
                    const status = result.filter(item => item.paramKey === 'STATUS');
                    const patientConditions = result.filter(item => item.paramKey === CommonConstants.PATIENT_CONDITION);
                    const subjectiveSigns = result.filter(item => item.paramKey === CommonConstants.SUBJECTIVE_SIGN);
                    const objectiveSigns = result.filter(item => item.paramKey === CommonConstants.OBJECTIVE_SIGN);
                    const surgeryTransferTos = result.filter(item => item.paramKey === CommonConstants.HOSP_SURGERY_TRANSFER_TO);
                    const surgeryOpinions = result.filter(item => item.paramKey === CommonConstants.HOSP_SURGERY_OPINION);
                    const transferPlaces = result.filter(item => item.paramKey === CommonConstants.TRANSFER_PLACE);
                    const reportWays = result.filter(item => item.paramKey === CommonConstants.HOSPI_REPORT_WAY);
                    const specialities = specialitiesResponse['result'];
                    return {
                        reasons,
                        procNames,
                        emergency,
                        roomType,
                        bedType,
                        status,
                        patientConditions,
                        subjectiveSigns,
                        objectiveSigns,
                        surgeryTransferTos,
                        surgeryOpinions,
                        transferPlaces,
                        reportWays,
                        specialities
                    };
                }
            )
        );
    }
}